import {HTMLAttributes, useMemo} from 'react'
import clsx from 'clsx'
import useShopConfig from '~/hooks/useShopConfig'

type PriceProps = {
    children?: number | null
} & HTMLAttributes<HTMLSpanElement>

const Price = ({className, children, ...rest}: PriceProps) => {
    const shopConfig = useShopConfig()

    const price = useMemo(() => {
        if (
            !shopConfig.shop ||
            isNaN(Number(children)) ||
            children === null ||
            children === undefined
        ) {
            return undefined
        }

        const {currency, language} = shopConfig.shop
        const formattedNumber = new Intl.NumberFormat(language!.isoCode ?? 'en', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(children)

        return currency!.pattern!.replace('%', formattedNumber).replace('$', currency!.symbol!)
    }, [children, shopConfig.shop])

    if (!price) {
        return null
    }

    return (
        <span className={clsx(className)} {...rest}>
            {price}
        </span>
    )
}

export default Price
